import Vue from "vue";

import WForm from "@/components/common/WForm.vue";
import WInput from "@/components/common/WInput.vue";
import WTextarea from "@/components/common/WTextarea.vue";
import WRadio from "@/components/common/WRadio.vue";
import WCheckbox from "@/components/common/WCheckbox.vue";
import WSelect from "@/components/common/WSelect.vue";

Vue.component("w-form", WForm);
Vue.component("w-input", WInput);
Vue.component("w-textarea", WTextarea);
Vue.component("w-checkbox", WCheckbox);
Vue.component("w-radio", WRadio);
Vue.component("w-select", WSelect);
